import React, {useContext} from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import SyncNavGuard from "../components/SyncNavGuard";
import LeftSideBar01 from "./LeftSideBar01";
import {RouteDefine} from "../../routes/RouteDefine";
import {useHistory} from "react-router-dom";
import {LayoutContext, LayoutDefine} from "../../context/LayoutContext";
import {useTranslation} from "react-i18next";

function SettingsCloseHeader() {
    const history = useHistory();
    const {t} = useTranslation();
    return (
        <div className="title-detail">
            <a
                onClick={() => history.push(RouteDefine.dashboard)}
                className="cursor-pointer pe-3 border-right-ams fs-20"
            >
                <i className="las la-times cl-font-zp fw-bold"/>
            </a>
            <span className="ml-3">{t("common.settings.backToApp")}</span>
        </div>
    );
}

export function DashboardTemplate({children}: HTMLElement | any) {
    const {layout}: any = useContext(LayoutContext);

    if (layout === LayoutDefine.legacySettings) {
        return <LegacySettingsLayout>{children}</LegacySettingsLayout>;
    }

    return <MainLayout>{children}</MainLayout>;
}

function MainLayout({children}: HTMLElement | any) {
    return (
        <div id="layout-wrapper">
            <Header/>
            <Navbar/>
            <div className="vertical-overlay"/>
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <SyncNavGuard>{children}</SyncNavGuard>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

/** V1 Economic settings shell only — do not use for V2 */
function LegacySettingsLayout({children}: HTMLElement | any) {
    return (
        <div id="layout-wrapper">
            <div className="header-detail p02">
                <div className="row h-100 align-items-center">
                    <div className="col-md-7">
                        <SettingsCloseHeader/>
                    </div>
                    <div className="col-md-5 d-flex justify-content-end"/>
                </div>
            </div>
            <div className="vertical-overlay"/>
            <div className="main-content">
                <div className="page-content mt-0 pt-3">
                    <div className="container-fluid">
                        <div className="row">
                            <LeftSideBar01/>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
